import EditableTextView from './EditableTextView';

export default EditableTextView;
